import React, { FC } from 'react'
import { Box, Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'

import { OTCTradingBalances } from '../TreasurySections/OTCTradingBalances'
// import { StakingBalancesAvailable } from '../TreasurySections/StakingBalancesAvailable'
// import { PendingBalances } from '../TreasurySections/PendingBalances'
import { GridRow } from '../../../../../components/GridRow'
import { cryptoBalancesSelector, fiatBalancesSelector, isBalancesLoadingSelector } from '../../../../../store/selectors'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}))

export const TradingBalance: FC = () => {
  const classes = useStyles()
  const cryptoBalances = useSelector(cryptoBalancesSelector)
  const fiatBalances = useSelector(fiatBalancesSelector)
  const loading = useSelector(isBalancesLoadingSelector)

  return (
    <Box className={classes.container}>
      <GridRow spacing={4}>
        <Grid item xs={6}>
          <OTCTradingBalances data={fiatBalances} loading={loading} currencyType={'fiat'} title={'Trading Balances'} />
        </Grid>

        <Grid item xs={6}>
          <OTCTradingBalances data={cryptoBalances} loading={loading} currencyType={'crypto'} />
        </Grid>

        {/* <Grid item xs={6}> */}
        {/*  <StakingBalancesAvailable title={'Staking Balances'} /> */}
        {/* </Grid> */}
      </GridRow>

      <GridRow spacing={4}>
        {/* <Grid item xs={6}> */}
        {/*  <OTCTradingBalances data={cryptoData} loading={loading} currencyType={'crypto'} /> */}
        {/* </Grid> */}

        {/* <Grid item xs={6}> */}
        {/*  <PendingBalances title={'Pending Balances'} /> */}
        {/* </Grid> */}
      </GridRow>
    </Box>
  )
}
